import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import HubsList from "./HubsList";
import Hub from "./Hub";
import { Role } from "common/Constants";
import ProtectedRoute from "common/ProtectedRoute";

export const HubsRouter: FC<{}> = () => {
  return (
    <Routes>
        <Route path="/:id" element={<Hub />} />
      <Route index element={<ProtectedRoute roles={[Role.Admin, Role.HubAdmin]}><HubsList /></ProtectedRoute>} />
    </Routes>
  );
};
